// import "./frontend.scss"
import React, { useState, useEffect, useMemo } from "react"
import HeaderMobileMenu from "../filter_page/sections/HeaderMobileMenu";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

var marker_details = [];
function Rem_filter_page(props) {
   
    const { t, i18n } = useTranslation('common');
    useEffect(() => {
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
    }, [])
  
    function openMenuBar() {
        document.getElementsByClassName('mobile_menu_module')[0].style.display = "block";
    }
    return (<header> 
        <div class="container_size">
            <div class="row align-items-center py-3">
                <div class="col-md-2 col-sm-6 text-center order1">
                    <a href={props.site_url} class="logo" width="100%">
                   
                        <img src={props.site_url+'/wp-content/uploads/2022/10/mastoria-logo.png'} />
                    </a>
                </div>
                <div class="col-md-8 col-sm-12 order2 text-center" >
                    <div  dangerouslySetInnerHTML={{__html: window.rem_single_page_ads.replace(/&nbsp;/g, '<br />')}} ></div>
                </div>
                <div class="col-md-2 col-sm-6 text-center order3">
                    {/* <div class="rem_menu_bar"  onClick={openMenuBar}>
                      <i class="fa-solid fa-bars"></i>
                    </div> */}
                    <div class="rem_menu_bar" >
                    <span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span>
                    </div>
                    <p class="head-btn">
                        {/* <a class="rem_help_nemu" href=""> Help </a> <span class="rem_verticalLine">|</span> */}
                        <a class="rem_signup_registration" href=""><span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span>
                            {/* <img src={props.site_url + "/wp-content/uploads/2022/08/noun-arrow-1776260.svg"} /> */}
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <HeaderMobileMenu  site_url={props?.site_url}></HeaderMobileMenu>
    </header>);
}

export default Rem_filter_page;